import { isEmpty } from 'lodash';
import { useEffect } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Slider as DsSlider } from '@hivebrite/design-system/Slider';

import TitleBlock from 'hb-react/frontoffice/components/BlocksRenderer/blocks/Items/TitleBlock';

import { useSliderItems } from './hooks/useSliderItems';
import type { SliderProps } from './types';

const ItemComponentWrapper =
  ({ as: Component, data }) =>
  ({ index, onTabKeyDown, ...item }) =>
    (
      <Component
        data={data}
        index={index}
        item={item}
        onTabKeyDown={onTabKeyDown}
      />
    );

export const Slider = ({
  blockId,
  data,
  fetchItems,
  itemLoader: ItemLoader,
  itemRenderer: ItemComponent,
  perPageBreakpoints,
  queryId,
  setBlockData,
  shouldDisplay = (input) => isEmpty(input?.['block-filters']),
  title,
}: SliderProps) => {
  const { fetchNextPage, isError, isLoading, items, total } = useSliderItems({
    fetchItems,
    queryId,
  });

  useEffect(() => {
    setBlockData(items);
  }, [blockId, items, setBlockData]);

  if (
    !shouldDisplay(data, isLoading) ||
    isError ||
    (!isLoading && total === 0)
  ) {
    return null;
  }

  return (
    <Box display="block" data-testid="block-slider">
      {/* @ts-expect-error: under-typed */}
      <TitleBlock isLoading={isLoading} itemsSize={total} title={title} />
      <Box display="block" mt={3}>
        <DsSlider
          ItemComponent={ItemComponentWrapper({ as: ItemComponent, data })}
          items={items}
          loading={isLoading}
          LoadingItemComponent={ItemLoader}
          /* @ts-expect-error: TODO: not implemented */
          onLoadMore={fetchNextPage}
          perPageBreakpoints={perPageBreakpoints}
          total={total}
        />
      </Box>
    </Box>
  );
};

export default Slider;
